export const siteName = "Jessie Trice Community Health System, Inc"
export const siteCode = "JTCHS"
export const continueUrl = "https://cfc.sharprpm.com"
export const siteDomains = [ "doctors.test", "doctor.test", "flcenterforchange.com" ] 
export const siteLogo = `/img/${siteCode}_354x123.png`
export const siteLogoSmall = `/img/${siteCode}_102x93.png`

export const doctors = [ 
    { value: "",                                 label: "* Select your primary"             },
    { value: "Tamisha Major",                    label: "Tamisha Major"         },
    { value: "Marie Jean Denis",                 label: "Marie Jean Denis"              },
    { value: "Ardeanna Smith",                   label: "Ardeanna Smith"         },
    { value: "Hector Rodriguez",                 label: "Hector Rodriguez"                 },
    { value: "Ardeanna Smith",                   label: "Ardeanna Smith"      },
    { value: "Angela Johnson",                   label: "Angela Johnson"             },
    { value: "Peggie Burgess",                   label: "Peggie Burgess"           },
    { value: "Michelle Blackwell",               label: "Michelle Blackwell"          },
    { value: "Shari Williams",                   label: "Shari Williams"            },

//  { value: "Dr. Leo Jusme, SVMD",              label: "Dr. Leo Jusme, SVMD DemoTest"      },
//  { value: "Dr. D. Northecide, SVMD",          label: "Dr. D. Northecide, SVMD DemoTest"  },
]

  //export default doctors;